<script setup lang="ts">
  defineProps({
    order: { type: Object, required: true },
  });
</script>
<template>
  <div class="summary">
    <div class="summary__content">
      <div class="item">
        <div class="item__property">
          {{ $t('Łączna kwota') + ':' }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currency_code" :decimals="order.currency_decimals" :value="order.items_gross" />
        </div>
      </div>
      <div class="item">
        <div class="item__property">
          {{ $t('Koszt dostawy') + ':' }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currency_code" :decimals="order.currency_decimals" :value="order.shipping_cost || 0" />
        </div>
      </div>
      <div class="item">
        <div class="item__property">
          {{ $t('Rabat') + ':' }}
        </div>
        <div class="item__value">
          <SfMoney :code="order.currency_code" :decimals="order.currency_decimals" :value="(order.discount_gross * -1) || 0" />
        </div>
      </div>
      <div class="item item--final">
        <div class="item__property">
          {{ $t('Do zapłaty') + ':' }}
          <span>{{ $t('z VAT') }}</span>
        </div>
        <div class="item__value">
          <SfMoney :code="order.currency_code" :decimals="order.currency_decimals" :value="order.total_gross" />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .summary {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;

    &__content {
      display: flex;
      flex-direction: column;
      gap: 0.375rem;
    }
  }

  .item {
    display: flex;
    justify-content: space-between;
    gap: 2rem;

    &__property {
      font-size: 0.875rem;
      line-height: 1.2rem;
    }

    &__value {
      font-weight: var(--font-weight-bold);
      line-height: 1.2rem;
    }

    &--final {
      .item__property {
        font-weight: var(--font-weight-bold);

        span {
          display: block;
          color: var(--secondary-color);
          font-weight: var(--font-weight-regular);
          font-size: 0.675rem;
        }
      }
    }
  }
</style>
